<section>
  <main *ngIf="this.trans" class="grid p-fluid col-12 lg:col-10">

    <!-- Información de la Factura Section -->
    <div class="col-12 md:col-4">
      <div>
        <b>{{ trans.referencia }}:</b>
      </div>
      <div>
        <p *ngIf="isLoading; else referencia">
          <p-skeleton width="10rem"></p-skeleton>
        </p>
        <ng-template #referencia>
          <p>{{ data.referencia }}</p>
        </ng-template>
      </div>
    </div>
    <div class="col-12 md:col-4">
      <div>
        <b>{{ trans.factura }}:</b>
      </div>
      <div>
        <p *ngIf="isLoading; else factura">
          <p-skeleton width="10rem"></p-skeleton>
        </p>
        <ng-template #factura>
          <p>{{ data.factura }}</p>
        </ng-template>
      </div>
    </div>
    <div class="col-12 md:col-4">
      <div>
        <b>{{ trans.loteFacturacion }}:</b>
      </div>
      <div>
        <p *ngIf="isLoading; else loteFacturacion">
          <p-skeleton width="10rem"></p-skeleton>
        </p>
        <ng-template #loteFacturacion>
          <p>{{ data.loteFacturacion }}</p>
        </ng-template>
      </div>
    </div>
    <div class="col-12 md:col-4">
      <div>
        <b>{{ trans.fechaRegistro }}:</b>
      </div>
      <div>
        <p *ngIf="isLoading; else fechaRegistro">
          <p-skeleton width="10rem"></p-skeleton>
        </p>
        <ng-template #fechaRegistro>
          <p>{{ data.fechaRegistro | date: defaultDateFormat }}</p>
        </ng-template>
      </div>
    </div>
    <div class="col-12 md:col-4">
      <div>
        <b>{{ trans.fechaVencimiento }}:</b>
      </div>
      <div>
        <p *ngIf="isLoading; else fechaVencimiento">
          <p-skeleton width="10rem"></p-skeleton>
        </p>
        <ng-template #fechaVencimiento>
          <p>{{ data.fechaVencimiento | date: defaultDateFormat }}</p>
        </ng-template>
      </div>
    </div>
    <div class="col-12 md:col-4">
      <div>
        <b>{{ trans.impuesto }}:</b>
      </div>
      <div>
        <p *ngIf="isLoading; else impuesto">
          <p-skeleton width="10rem"></p-skeleton>
        </p>
        <ng-template #impuesto>
          <p>{{ data.impuesto }}</p>
        </ng-template>
      </div>
    </div>
    <div class="col-12 md:col-4">
      <div>
        <b>{{ trans.concepto }}:</b>
      </div>
      <div>
        <p *ngIf="isLoading; else concepto">
          <p-skeleton width="10rem"></p-skeleton>
        </p>
        <ng-template #concepto>
          <p>{{ data.concepto }}</p>
        </ng-template>
      </div>
    </div>
    <div class="col-12 md:col-4">
      <div>
        <b>{{ trans.nombreTramite }}:</b>
      </div>
      <div>
        <p *ngIf="isLoading; else nombreTramite">
          <p-skeleton width="10rem"></p-skeleton>
        </p>
        <ng-template #nombreTramite>
          <p>{{ data.nombreTramite }}</p>
        </ng-template>
      </div>
    </div>
    <div class="col-12">
      <div>
        <b>{{ trans.totalPago }}:</b>
      </div>
      <div>
        <p *ngIf="isLoading; else totalPago">
          <p-skeleton width="10rem"></p-skeleton>
        </p>
        <ng-template #totalPago>
          <p>{{ data.totalPago | currency }}</p>
        </ng-template>
      </div>
    </div>
  </main>
</section>